import { defineComponent as _defineComponent } from 'vue'
import SingleOwnerOutstandingFeesBlock from 'ah-trades/src/components/fees/SingleOwnerOutstandingFeesBlock.vue';
import { Client } from 'ah-api-gateways';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, ref, watch } from 'vue';
import { getServices } from '@/app/services';
import { useRoute, useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleClientOutstandingFeesView',
  setup(__props) {

const requestManager = useRequestManager().manager;
const services = getServices();
const route = useRoute();
const router = useRouter();

const client = ref<Client | null>(null);

const clientId = computed(() => route.params.clientOrPartnerId);

function onClientOrPartnerIdChange() {
  requestManager
    .sameOrCancelAndNew('getClient', services.client.getClient(clientId.value))
    .subscribe((response) => (client.value = response));
}

watch(() => route.params.clientOrPartnerId, onClientOrPartnerIdChange, { immediate: true });

function goBack() {
  router.push('../');
}

return { __sfc: true,requestManager, services, route, router, client, clientId, onClientOrPartnerIdChange, goBack, SingleOwnerOutstandingFeesBlock }
}

})